var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-btn",style:({
    width: _vm.width,
    height: _vm.height,
    backgroundImage: _vm.isHover ? `url(${_vm.hoverBgImage})` : `url(${_vm.bgImage})`,
  }),on:{"mouseover":function($event){_vm.isHover = true},"mouseleave":function($event){_vm.isHover = false}}},[_c('span',{staticClass:"btn-text",style:({ fontSize: _vm.fontSize })},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }